<!--
 * @Description: 教职工详情 惩处
 * @Author: 张天伟
 * @Date: 2023-03-08 17:09:34
 * @LastEditors: PF
 * @LastEditTime: 2025-02-13 14:06:58
-->

<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="惩处名称" label-align="right" align="left" width="120px" span="2">{{item.ccmc}}</el-descriptions-item>
      <el-descriptions-item label="纪律处分" label-align="right" align="left" width="120px" span="2">{{item.jlcfbt}}</el-descriptions-item>
      <el-descriptions-item label="惩处原因" label-align="right" align="left" width="120px" span="2">{{item.ccyy}}</el-descriptions-item>
      <el-descriptions-item label="惩处内容" label-align="right" align="left" width="120px" span="2">{{item.ccnr}}</el-descriptions-item>
      <el-descriptions-item label="惩处单位" label-align="right" align="left" width="120px" span="2">{{item.ccdw}}</el-descriptions-item>
      <el-descriptions-item label="惩处文号" label-align="right" align="left" width="120px" span="2">{{item.ccwh}}</el-descriptions-item>
      <el-descriptions-item label="惩处日期" label-align="right" align="left" width="120px" span="2">{{item.ccrq}}</el-descriptions-item>
      <el-descriptions-item label="惩处撤销日期" label-align="right" align="left" width="120px" span="2">{{item.cccxrq}}</el-descriptions-item>
      <el-descriptions-item label="惩处撤销文号" label-align="right" align="left" width="120px" span="2">{{item.cccxwh}}</el-descriptions-item>
      <el-descriptions-item label="惩处撤销原因" label-align="right" align="left" width="120px" span="2">{{item.cccxyy}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigongchengchu/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
